import { useNavigate } from 'react-router-dom';
import { Card, Stack, Typography } from '@mui/material';
import { TopNextButton, UilCalenderIcon } from 'components';
import { baseColors } from 'utils/constants';

type Props = {
  mainBodyImage: string;
  mainBodyImage2: string;
  title: string;
};

const PlanCard = (props: Props) => {
  const { mainBodyImage, mainBodyImage2, title } = props;
  const navigate = useNavigate();
  const handleNext = (): void => {
    navigate('/rental/mypage/');
  };

  return (
    <Card sx={{ width: '300px', paddingBottom: '20px' }}>
      <Typography
        variant="h5"
        sx={{
          color: baseColors.white,
          fontSize: '18px',
          backgroundColor: baseColors.red,
          borderRadius: '10px 10px 0 0',
          padding: '10px 0',
          textAlign: 'center',
          position: 'relative'
        }}
      >
        <div style={{ display: 'inline-block', position: 'absolute', top: '0.75rem', left: '0.5rem' }}>
          <UilCalenderIcon />
        </div>
        {title}
      </Typography>
      <Stack
        direction="row"
        spacing={0}
        sx={{
          padding: '20px 10px 0 10px',
          justifyContent: 'space-around',
          alignItems: 'center'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <img src={mainBodyImage} alt="mobile-router" style={{ paddingBottom: '10px', maxHeight: '130px' }} />
          <img src={mainBodyImage2} alt="mobile-router" style={{ paddingBottom: '10px', maxHeight: '130px' }} />
        </div>
      </Stack>
      <TopNextButton onClick={handleNext} />
    </Card>
  );
};
export default PlanCard;
